import { useState } from "react";

import { CASE_DOCUMENT_STATUS, CaseDocumentFileModel, CaseDocumentModel } from "@shared/models";
import { hasParsingFailed } from "@containers/Cases/utils/caseDocuments";

/**
 * Whether the document's last parsing saved nothing. The files a parsing reads are remembered while it runs, as a
 * failed replacement puts the replaced files back; a document already parsed when this mounts goes by its status.
 */
const useCaseDocumentParsingFailed = (caseDocument?: CaseDocumentModel) => {
  const [parsingFiles, setParsingFiles] = useState<CaseDocumentFileModel[] | null>(null);
  const isParsing = caseDocument?.status === CASE_DOCUMENT_STATUS.PARSING;
  const files = caseDocument?.files;

  if (isParsing && files && files !== parsingFiles) {
    setParsingFiles(files);
  }

  if (!caseDocument) return false;

  return parsingFiles
    ? hasParsingFailed(caseDocument, parsingFiles)
    : caseDocument.status === CASE_DOCUMENT_STATUS.FAILED;
};

export default useCaseDocumentParsingFailed;
